<template>
  <v-container fluid>
    <a-input-group compact class="mb-2">
      <a-date-picker v-model="form.date" :locale="locale" placeholder="日期" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
        size="large" :allowClear="false" style="width:10%" />
      <a-select v-model="form.names" :options="names" mode="multiple" placeholder="请选择" size="large" style="width:70%;">
      </a-select>
      <div style="width:20%;">
        <a-button type="primary" size="large" @click="getdata()">
          查询
        </a-button>
        <a-button class="ml-2" size="large" @click="getdata('download')">
          导出EXECL
        </a-button>
      </div>
    </a-input-group>
    <a-table :columns="columns" :data-source="data" bordered size="small" :pagination="false"
      :locale="{ emptyText: '暂无数据' }" :scroll="{ x: 'calc(700px + 50%)' }" />
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "OrderCalcHis",
  data() {
    return {
      locale,
      form: {
        date: '2026-09-01',
        names: [
          // "驻马店",
          // "周口",
          // "许昌",
          // "漯河",
          // "平顶山",

          // "郑州",
          // "开封",
          // "商丘",
          // "信阳",
          // "南阳",
          // "驻马店",
          // "周口",

          "郑州",
          // "安阳",//5
          // "周口",//9
          // "许昌",//4
          "洛阳",//10
          "南阳",//12
          // "濮阳",//5
          // "新乡",//4
          "驻马店",//13
          // "商丘",//8
          "信阳",//11
          // "漯河",//8
          // "偃师",
          // "长葛",
          // "临颍",
          // "桐柏",
          // "汝州",
          // "鄢陵",
          // "柘城",
          // "辉县",
          // "邓州",
          // "三门峡",//4
          // "太康",
          // "固始",
          // "孟州",
          // "开封",//4
          // "禹州",
          // "焦作",//5
          // "鲁山",
          // "襄城",
          // "祥符",
          // "滑县",
          // "长垣",
          // "夏邑",
          // "通许",
          // "尉氏",
          // "平顶山",//7
          // "原阳",
          // "鹤壁",//3
          // "温县",
          // "舞钢",
          // "获嘉",
          // "杞县",
          // "内黄",
          // "西华",
          // "灵宝",
          // "济源",//2
        ],
      },
      data: [],
      columns: [],
      names: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: {
  },
  watch: {

  },
  mounted() {
    this.height = window.innerHeight - 280;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 280;
    };
    this.init();
  },
  methods: {
    init() {
      this.$api.doAPI("/waybillhis/calcinit", this.form).then((res) => {
        if (res.code === 0) {
          this.names = res.data.names;
          this.form.names = res.data.default_names;
          this.getdata();
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybillhis/calc", { ...this.form, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action && res.data.url) {
            return this.$download(res.data.url, res.data.name);;
          }
          this.makedata(res.data);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makedata({ sources, targets }) {
      let columns = [];
      for (let i = 0; i < sources.length; i++) {
        let { from, to } = sources[i];
        let key = `${from}-${to}`;
        columns.push({
          title: key,
          children: [
            {
              title: "出发",
              children: [
                {
                  title: '12T',
                  dataIndex: `${key}__12T`,
                  width: 80,
                  align: 'center',
                  customCell: (record, rowIndex) => {
                    return {
                      style: {
                        fontSize: '11px',
                      }
                    };
                  },
                  customRender: (value, record, index) => {
                    let vehicle_type = "12";
                    let time = record[`${key}__${vehicle_type}T`];
                    let vehicle_number = record[`${key}__${vehicle_type}__vehicle_number`];
                    if (time && vehicle_number) {
                      return <div>
                        <p style="font-size:10px;">{time}</p>
                        <p>{vehicle_number}</p>
                      </div>;
                    }
                    return value;
                  },
                },
                {
                  title: '30T',
                  dataIndex: `${key}__30T`,
                  width: 80,
                  align: 'center',
                  customCell: (record, rowIndex) => {
                    return {
                      style: {
                        fontSize: '11px',
                      }
                    };
                  },
                  customRender: (value, record, index) => {
                    let vehicle_type = "30";
                    let time = record[`${key}__${vehicle_type}T`];
                    let vehicle_number = record[`${key}__${vehicle_type}__vehicle_number`];
                    if (time && vehicle_number) {
                      return <div>
                        <p style="font-size:10px;">{time}</p>
                        <p>{vehicle_number}</p>
                      </div>;
                    }
                    return value;
                  },
                },
              ]
            },
            {
              title: '到达',
              dataIndex: `${key}__time`,
              width: 80,
              align: 'center',
              customCell: (record, rowIndex) => {
                let [departure, destination] = key.split('-');
                if (destination === '郑州') {
                  return {
                    style: {
                      backgroundColor: '#FFD400',
                      fontSize: '11px',
                    },
                  };
                }
                if (destination === '驻马店') {
                  return {
                    style: {
                      backgroundColor: '#A6DFF2',
                      fontSize: '11px',
                    },
                  };
                }
                return {
                  style: {
                    backgroundColor: '#F6FFED',
                    fontSize: '11px',
                  },
                };
              },
              customRender: (value, record, index) => {
                let vehicle_type = record[`${key}__vehicle_type`];
                let vehicle_number = record[`${key}__${vehicle_type}__vehicle_number`];
                let vehicle_times1 = record[`${key}__${vehicle_type}__vehicle_times1`];
                let vehicle_times2 = record[`${key}__${vehicle_type}__vehicle_times2`];
                if (record[`${key}__time`]) {
                  if (vehicle_times1 > 0 || vehicle_times2 > 0) {
                    return <div>
                      <p style="font-size:10px;">{record[`${key}__time`]}</p>
                      <p style="color:red;">{vehicle_number}</p>
                    </div>;
                  }
                  else {
                    return <div>
                      <p style="font-size:10px;">{record[`${key}__time`]}</p>
                      <p>{vehicle_number}</p>
                    </div>;
                  }
                }
                return value;
              },
            }
          ],
        });
      }
      let list = [];
      let length = targets[0]?.ranges?.length || 0;
      let counts = {};
      for (let i = 0; i < length; i++) {
        let item = {};
        for (let j = 0; j < sources.length; j++) {
          let { from, to } = sources[j];
          let key = `${from}-${to}`;
          let target = targets.find(n => n.from === from && n.to === to);
          let {
            type,
            vehicle_type,
            vehicle_number,
            vehicle_times1,
            vehicle_times2,
            time1,
            time2,
          } = target.ranges[i];
          if (vehicle_number && type === 2) {
            if (vehicle_times2 > 0) {
              vehicle_number += `(${vehicle_times2})`;
            }
            else if (vehicle_times1 > 0) {
              vehicle_number += `(+${vehicle_times1})`;
            }
          }
          item[`${key}__vehicle_type`] = vehicle_type;
          item[`${key}__12T`] = vehicle_type === "12" && vehicle_number ? time1 : "";
          item[`${key}__12__vehicle_times1`] = vehicle_type === "12" && vehicle_times1 ? vehicle_times1 : 0;
          item[`${key}__12__vehicle_times2`] = vehicle_type === "12" && vehicle_times2 ? vehicle_times2 : 0;
          if (item[`${key}__12T`]) {
            if (!counts[`${key}__12T`]) counts[`${key}__12T`] = 0;
            counts[`${key}__12T`] = counts[`${key}__12T`] + 1;
          }
          item[`${key}__12__vehicle_number`] = vehicle_type === "12" ? vehicle_number || "" : "";

          item[`${key}__30T`] = vehicle_type === "30" && vehicle_number ? time1 : "";
          item[`${key}__30__vehicle_times1`] = vehicle_type === "30" && vehicle_times1 ? vehicle_times1 : 0;
          item[`${key}__30__vehicle_times2`] = vehicle_type === "30" && vehicle_times2 ? vehicle_times2 : 0;
          if (item[`${key}__30T`]) {
            if (!counts[`${key}__30T`]) counts[`${key}__30T`] = 0;
            counts[`${key}__30T`] = counts[`${key}__30T`] + 1;
          }
          item[`${key}__30__vehicle_number`] = vehicle_type === "30" ? vehicle_number || "" : "";
          item[`${key}__time`] = time2 || "";
        }
        list.push(item);
      }
      this.data = list;
      columns.forEach(n => {
        let keys = _.keys(counts);
        for (let key of keys) {
          if (key.includes(n.title)) {
            n.children.forEach(m => {
              if (m.title === "出发") {
                m.children.forEach(o => {
                  if (o.dataIndex === key) {
                    o.title = `${o.title}(${counts[key]})`
                  }
                });
              }
            });
          }
        }
      });
      this.columns = columns;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-header-column {
  font-size: 12px;
}

/deep/ .ant-table-row-cell-break-word {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/deep/ .ant-table-thead {
  font-size: 10px !important;
}

/deep/ .ant-collapse>.ant-collapse-item>.ant-collapse-header {
  padding: 6px 8px;
  padding-left: 30px;
}

/deep/ p {
  margin: 0;
  padding: 0;
}
</style>
